<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        md="6"
      >
        <validation-provider
          #default="{ errors }"
          name="Play ready server url"
          rules="required"
        >
          <input-field
            name="play_ready-playReadyServerUrl"
            label="Play ready server url *"
            :error="errors.length ? errors[0] : null"
            label-position="top"
          >
            <b-form-input
              id="play_ready-playReadyServerUrl"
              v-model="settings.playReadyServerUrl"
              :state="errors.length > 0 ? false:null"
              placeholder="Enter play ready server url..."
            />
          </input-field>
        </validation-provider>
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <validation-provider
          #default="{ errors }"
          name="Client cert file"
          rules="required"
        >
          <input-field
            name="play_ready-clientCertFile"
            :error="errors.length ? errors[0] : null"
            label="Client Cert File *"
            label-position="top"
          >
            <b-form-input
              id="play_ready-clientCertFile"
              v-model="settings.clientCertFile"
              :state="errors.length > 0 ? false:null"
              placeholder="Enter client cert file..."
            />
          </input-field>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="12"
        md="6"
      >
        <validation-provider
          #default="{ errors }"
          name="Client Cert Private Key File"
          rules="required"
        >
          <input-field
            name="play_ready-clientCertPrivateKeyFile"
            :error="errors.length ? errors[0] : null"
            label="Client Cert Private Key File *"
            label-position="top"
          >
            <b-form-input
              id="play_ready-clientCertPrivateKeyFile"
              v-model="settings.clientCertPrivateKeyFile"
              :state="errors.length > 0 ? false:null"
              placeholder="Enter client cert private key file..."
            />
          </input-field>
        </validation-provider>
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <validation-provider
          #default="{ errors }"
          name="Client Cert Private Key Password"
          rules="required"
        >
          <input-field
            name="play_ready-clientCertPrivateKeyPassword"
            :error="errors.length ? errors[0] : null"
            label="Client Cert Private Key Password *"
            label-position="top"
          >
            <b-form-input
              id="play_ready-clientCertPrivateKeyPassword"
              v-model="settings.clientCertPrivateKeyPassword"
              :state="errors.length > 0 ? false:null"
              type="password"
              placeholder="Enter client cert private key password..."
            />
          </input-field>
        </validation-provider>
      </b-col>
    </b-row>
  </div>
</template>
<script>

import InputField from '@/components/form/InputField.vue'
import { ValidationProvider } from 'vee-validate'
import { required } from '@validations'

export default {
  name: 'PlayReady',
  components: {
    InputField,
    ValidationProvider,
  },
  props: {
    settings: {
      type: Object,
      required: true,
    },
  },
  data() {
    return { required }
  },

}
</script>

<style>

</style>
